import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ConstellationDetailPage from './pages/ConstellationDetailPage';
import MatchPage from './pages/MatchPage';
import DivinationPage from './pages/DivinationPage';
import SearchPage from './pages/SearchPage';
import HoroscopePage from './pages/HoroscopePage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/constellation/:name" element={<ConstellationDetailPage />} />
            <Route path="/match" element={<MatchPage />} />
            <Route path="/divination" element={<DivinationPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/horoscope" element={<HoroscopePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
